import React from 'react';

export default function PictoBarbecue40() {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_840_1001)">
        <path d="M22 29C29.732 29 36 23.1797 36 16H8C8 23.1797 14.268 29 22 29Z" fill="#DAD8D2" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M36 15C36.5523 15 37 15.4477 37 16C37 23.8005 30.2132 30 22 30C13.7868 30 7 23.8005 7 16C7 15.4477 7.44772 15 8 15H36ZM8.0408 17C8.01377 16.67 8 16.3365 8 16H36C36 16.3365 35.9862 16.67 35.9592 17C35.4093 23.7124 29.3696 29 22 29C14.6304 29 8.59071 23.7124 8.0408 17Z"
          fill="#142138"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.5 18C1.5 17.7239 1.72386 17.5 2 17.5H7C7.27614 17.5 7.5 17.7239 7.5 18C7.5 18.2761 7.27614 18.5 7 18.5H2C1.72386 18.5 1.5 18.2761 1.5 18Z"
          fill="#142138"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.1436 28.5211C16.4081 28.6004 16.5581 28.8792 16.4788 29.1437L13.4788 39.1437C13.3995 39.4082 13.1207 39.5583 12.8562 39.4789C12.5917 39.3996 12.4416 39.1208 12.521 38.8563L15.521 28.8563C15.6003 28.5918 15.8791 28.4417 16.1436 28.5211Z"
          fill="#142138"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27.8562 28.5211C28.1207 28.4417 28.3995 28.5918 28.4788 28.8563L31.4788 38.8563C31.5581 39.1208 31.4081 39.3996 31.1436 39.4789C30.8791 39.5583 30.6003 39.4082 30.521 39.1437L27.521 29.1437C27.4416 28.8792 27.5917 28.6004 27.8562 28.5211Z"
          fill="#142138"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.5 34.5C14.5 34.2239 14.7239 34 15 34H29C29.2761 34 29.5 34.2239 29.5 34.5C29.5 34.7761 29.2761 35 29 35H15C14.7239 35 14.5 34.7761 14.5 34.5Z"
          fill="#142138"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.9287 0.742767C22.0708 0.979557 21.994 1.28669 21.7572 1.42876C21.3915 1.64824 20.8157 2.10635 20.336 2.73944C19.8577 3.37087 19.5 4.14222 19.5 5.00001C19.5 5.53331 19.631 5.91165 19.8171 6.2155C20.0103 6.53113 20.2741 6.78654 20.5845 7.06587C20.6236 7.10109 20.6638 7.13683 20.7048 7.17323C21.2793 7.68404 22 8.32488 22 9.50001C22 10.1569 21.6787 10.7666 21.3216 11.1951C21.1392 11.4139 20.9324 11.6043 20.7227 11.7442C20.5271 11.8745 20.2707 12 20 12C19.7239 12 19.5 11.7762 19.5 11.5C19.5 11.2239 19.7239 11 20 11C19.9972 11 19.9958 11 19.9958 10.9998C19.9956 10.9986 20.0531 10.9887 20.168 10.9121C20.2864 10.8332 20.4233 10.7111 20.5534 10.5549C20.8213 10.2334 21 9.84315 21 9.50001C21 8.78376 20.605 8.42882 19.9813 7.86832C19.9597 7.84886 19.9377 7.82914 19.9155 7.80916C19.6009 7.52599 19.2397 7.18765 18.9642 6.73765C18.6815 6.27588 18.5 5.71672 18.5 5.00001C18.5 3.85781 18.9756 2.87916 19.539 2.13559C20.101 1.39368 20.7752 0.851792 21.2428 0.571268C21.4795 0.429194 21.7867 0.505977 21.9287 0.742767Z"
          fill="#142138"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.3536 2.14645C24.5488 2.34171 24.5488 2.65829 24.3536 2.85355C24.315 2.89207 24.2748 2.9316 24.2333 2.97236C23.7144 3.48222 23 4.18416 23 5.5C23 6.28016 23.3588 6.6517 23.8536 7.14645C23.8587 7.1516 23.8639 7.15677 23.8691 7.16195C24.3718 7.66458 25 8.2926 25 9.5C25 10.6333 24.4 11.5 23.5 11.5C23.2239 11.5 23 11.2761 23 11C23 10.7239 23.2239 10.5 23.5 10.5C23.6 10.5 24 10.3667 24 9.5C24 8.71984 23.6412 8.3483 23.1464 7.85355L23.1309 7.83805C22.6282 7.33542 22 6.7074 22 5.5C22 3.75085 22.9978 2.77908 23.5273 2.26343C23.5704 2.22147 23.6104 2.18254 23.6464 2.14645C23.8417 1.95118 24.1583 1.95118 24.3536 2.14645Z"
          fill="#142138"
        />
      </g>
      <defs>
        <clipPath id="clip0_840_1001">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
